import { Directive, inject, input, Signal } from '@angular/core';
import { TRACKABLE_COMPONENT_NAME, TRACKABLE_SCREEN_NAME } from '../models/trackable-component';
import { EventTrackingService } from '../services/event-tracking.service';
import { PageNameService } from '../services/page-name.service';

@Directive({
  selector: '[trackClick]',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class TrackClickDirective {
  trackClick = input<Object>();

  trackingService = inject(EventTrackingService);
  pageNameService = inject(PageNameService);

  componentName = inject(TRACKABLE_COMPONENT_NAME, { optional: true });
  screenName = inject(TRACKABLE_SCREEN_NAME, { optional: true });

  get eventData() {
    return this.trackClick() as any;
  }

  onClick() {
    if (this.isThereDelayedDataSource()) {
      this.trackClickWithDelayedDataSource();
    } else {
      this.trackClickSynchronously();
    }
  }

  private isThereDelayedDataSource() {
    return this.eventData._resolveWithDelay;
  }

  private trackClickSynchronously() {
    this.trackingService.trackEvent({
      eventType: 'click',
      component: this.componentName,
      screenName: this.screenName || this.pageNameService.activeScreenName(),
      timestamp: new Date().toISOString(),
      ...this.eventData,
    });
  }

  private trackClickWithDelayedDataSource() {
    const delayedResolveSource = this.eventData[this.eventData._resolveWithDelayPropName] as Signal<string>;

    setTimeout(() => {
      this.trackingService.trackEvent({
        eventType: 'click',
        component: this.componentName,
        screenName: this.screenName || this.pageNameService.activeScreenName(),
        timestamp: new Date().toISOString(),

        ...(() => {
          const { _resolveWithDelayPropName, _resolveWithDelay, ...filteredData } = this.eventData;
          return filteredData;
        })(),
        [this.eventData._resolveWithDelayPropName]: delayedResolveSource(),
      });
    }, this.eventData._resolveWithDelay);
  }
}
